/** Fondos KEORA: dibujados por KEORA y de uso libre (public/fondos). `light`: va con letra oscura. */
export const BACKGROUNDS: { key: string; name: string; light?: boolean }[] = [
  { key: 'amanecer', name: 'Amanecer' },
  { key: 'cielo', name: 'Cielo' },
  { key: 'noche', name: 'Noche estrellada' },
  { key: 'luz', name: 'Rayos de luz' },
  { key: 'aurora', name: 'Aurora' },
  { key: 'oceano', name: 'Océano' },
  { key: 'campo', name: 'Campo' },
  { key: 'marfil', name: 'Marfil', light: true },
  { key: 'bokeh', name: 'Luces' },
  { key: 'cruz', name: 'Cruz' },
  { key: 'vitral', name: 'Vitral' },
  { key: 'carbon', name: 'Carbón' },
];

export const presetUrl = (key: string) => `/fondos/${key}.svg`;
export const isLightPreset = (key: string | null | undefined) => Boolean(key && BACKGROUNDS.find((b) => b.key === key)?.light);
